module.exports = __webpack_public_path__ + "static/media/anfora_madera_perla.7d5ae40e.png";